<ami-dialog-message [setting]="message"></ami-dialog-message>

<ami-table-actions
[settings]="table.settings"
[data]="table.data"
[actions]="table.actions"
(action)="onReciveAction($event)"
>
</ami-table-actions>

<div *ngIf="idDocument">
  <pg-transfer-detail
    [idDocument]="idDocument"
    (onHideData)="idDocument=undefined"
  >
  </pg-transfer-detail>
</div>
